import styled from "styled-components";
import Tag from "../../shared/controls/tag";
export const StyledTag = styled(Tag)`
  cursor: pointer;
`;
export const StyledTagSimple = styled(Tag)`
`;
